import { createAction } from "redux-act";

export const SetPreferenceAction = createAction("Preference - Set");
export const SetPreferencesAction = createAction("Preferences - Set");
export const LoadPreferencesAction = createAction("Preferences - Load");
